// QC Inspector Qualifications API — GAP-012 closure
import ApiCall from "./apicall";

export const qciApi = {
  list: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return ApiCall.get(`/qc-inspector-qualifications${qs ? `?${qs}` : ""}`);
  },
  byUser: (user_id) => ApiCall.get(`/qc-inspector-qualifications/by-user/${user_id}`),
  get: (id) => ApiCall.get(`/qc-inspector-qualifications/${id}`),
  create: (payload) => ApiCall.post("/qc-inspector-qualifications", payload),
  update: (id, payload) => ApiCall.put(`/qc-inspector-qualifications/${id}`, payload),
  remove: (id) => ApiCall.delete(`/qc-inspector-qualifications/${id}`),
};

export const QCI_METHOD_LABELS = {
  "ASNT-SNT-TC-1A": "ASNT SNT-TC-1A",
  "ICC-AWS-CWI": "ICC / AWS CWI",
  "AWS-CWB": "AWS CWB",
  "internal_training": "Internal Training",
  "other": "Other",
};

export const QCI_STATUS_LABELS = {
  active: "Active",
  suspended: "Suspended",
  expired: "Expired",
  revoked: "Revoked",
};

export const QCI_STATUS_COLORS = {
  active: "success",
  suspended: "warning",
  expired: "error",
  revoked: "error",
};

export function isExpiringSoon(certified_to_date, days = 60) {
  if (!certified_to_date) return false;
  const exp = new Date(certified_to_date);
  const now = new Date();
  const horizon = new Date(now);
  horizon.setDate(horizon.getDate() + days);
  return exp <= horizon && exp >= now;
}
